/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { githubInstallApp } from "../funcs/githubInstallApp.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import * as components from "../models/components/index.js";
import { unwrapAsync } from "../types/fp.js";

export class Github extends ClientSDK {
  /**
   * Install GitHub App
   *
   * @remarks
   * Start installing the Teral GitHub App for your workspace. Returns a GitHub
   * App install URL: open it in a browser to install the app and grant
   * repository access. After installation GitHub returns to Teral, which binds
   * the installation to your workspace and lands you in the workspace settings.
   *
   * Installation is workspace-wide and takes no parameters. Once installed, link
   * repositories to individual apps with the `git` field on `apps.createApp` and
   * `apps.updateApp`.
   *
   * **Required Permissions**
   *
   * Your root key must have the following permission:
   * - `workspace.*.install_github`
   */
  async installApp(
    options?: RequestOptions,
  ): Promise<components.V1GithubInstallAppResponseBody> {
    return unwrapAsync(githubInstallApp(
      this,
      options,
    ));
  }
}
